/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";
import "assets/css/styles.css";

import Layout from 'views/layouts/Layout';
import Home from "views/examples/Home.js";
import Nosotros from "views/pages/Nosotros.js";
import Talleres from "views/pages/Talleres.js";
import NuestroEspacio from "views/pages/NuestroEspacio";
import NuestrosProgramas from "views/pages/NuestrosProgramas";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/talleres" element={<Talleres />} />
        <Route path="/programas" element={<NuestrosProgramas />} />
        <Route path="/galeria-fotos" element={<NuestroEspacio />} />
      </Route>
      {/* <Navigate to="/" /> */}
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
